import axios from "../../config/axiosConfig";
import {
  GENERAL_PURCHASE_RETURN_REGISTER_REPORT_REQUEST,
  GENERAL_PURCHASE_RETURN_REGISTER_REPORT_SUCCESS,
  GENERAL_PURCHASE_RETURN_REGISTER_REPORT_FAILURE
} from "../types/general-purchase-return-report-types";

export const getGeneralPurchaseReturnRegisterReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GENERAL_PURCHASE_RETURN_REGISTER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
      // console.log('params.book_ids',params);
      console.log('params.fromDate',params?.fromDate);
      console.log('params.toDate',params?.toDate);
      
      const defaultParams2 = {
        // book_ids: params?.book_ids,
        filterType: params?.filterType, 
        selectedBills: params?.selectedBills, 
        selectedParties: params?.selectedParties, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/general-purchase-return-bill/getReport?${queryString}`;

      console.log('Complete API Request URL: ', fullUrl);

      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: GENERAL_PURCHASE_RETURN_REGISTER_REPORT_SUCCESS, payload: response.data });
        }  
      }).catch((error) => {
        console.error("Error fetching Purchase Register Report:", error);
        dispatch({ type: GENERAL_PURCHASE_RETURN_REGISTER_REPORT_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching Purchase Register Report:", error);
      dispatch({ type: GENERAL_PURCHASE_RETURN_REGISTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearGeneralPurchaseReturnRegisterReport = () => {
  return async (dispatch) => {
    dispatch({ type: GENERAL_PURCHASE_RETURN_REGISTER_REPORT_SUCCESS, payload: {} });
  }
}